import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Shield, TrendingUp, Lock, AlertCircle, Search, FileText, Heart, Radio, Banknote } from 'lucide-react';

const Services = () => {
  const { t, language } = useLanguage();
  const navigate = useNavigate();

  const icons = [Shield, TrendingUp, Lock, AlertCircle, Search, FileText, Heart, Radio, Banknote];

  const specialLabel = { fr: '→ Cliquez pour découvrir nos agents spéciaux', ru: '→ Нажмите, чтобы познакомиться с нашими спецагентами', ko: '→ 클릭하여 특수 요원을 만나보세요', zh: '→ 点击查看我们的特工' };

  return (
    <div className="min-h-screen bg-[#0a0a0a] py-24 px-6">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <div className="text-8xl font-light text-[#d4c5a9] mb-8">&</div>
          <h1 className="text-5xl md:text-6xl font-light text-white mb-6 tracking-wide">
            {t.services.title}
          </h1>
        </div>

        {/* Services Grid */}
        <div className="space-y-12">
          {t.services.items.map((service, index) => {
            const Icon = icons[index] || Shield;
            const isSpecial = service.title.includes('🔞');
            return (
              <div
                key={index}
                onClick={() => isSpecial && navigate('/special-services')}
                className={`group grid grid-cols-1 lg:grid-cols-12 gap-8 items-center ${isSpecial ? 'cursor-pointer' : ''}`}
              >
                {/* Icon & Number */}
                <div className="lg:col-span-2 text-center lg:text-left">
                  <div className={`inline-block p-6 bg-gradient-to-br ${isSpecial ? 'from-red-500/10' : 'from-[#d4c5a9]/10'} to-transparent border ${isSpecial ? 'border-red-500/20' : 'border-[#d4c5a9]/20'} rounded-lg ${isSpecial ? 'group-hover:border-red-500/50' : 'group-hover:border-[#d4c5a9]/50'} transition-all duration-300`}>
                    <Icon className={`w-12 h-12 ${isSpecial ? 'text-red-500' : 'text-[#d4c5a9]'}`} />
                  </div>
                  <div className="text-6xl font-thin text-gray-800 mt-4">
                    0{index + 1}
                  </div>
                </div>

                {/* Content */}
                <div className={`lg:col-span-10 bg-gradient-to-br from-gray-900/50 to-gray-900/30 border border-gray-800 rounded-lg p-8 ${isSpecial ? 'group-hover:border-red-500/50 group-hover:from-red-900/20' : 'group-hover:border-[#d4c5a9]/50'} transition-all duration-300 ${isSpecial ? 'group-hover:scale-105' : ''}`}>
                  <h3 className={`text-3xl font-light text-white mb-4 ${isSpecial ? 'group-hover:text-red-400' : 'group-hover:text-[#d4c5a9]'} transition-colors`}>
                    {service.title}
                  </h3>
                  <p className="text-lg text-gray-400 leading-relaxed">
                    {service.description}
                  </p>
                  {isSpecial && (
                    <p className="text-sm text-red-400 mt-4 italic">
                      {specialLabel[language]}
                    </p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Services;